export const normalizeContentfulUrl = (src: string | null) => {
    if (!src) return "";
    if (src.startsWith("//")) { return `https:${src}`; } 
    else if (src.startsWith("/")) { return `https:/${src}`;}
    else { return src; } // already absolute 
}

export const normalizeContentfulUrl1 = (src: string) => {
    if (!src) return "";

    let absoluteUrl = src;

    // Contentful-style URLs
    if (src.startsWith("//")) {
        absoluteUrl = `https:${src}`;
    } else if (src.startsWith("/")) {
        absoluteUrl = `https://images.ctfassets.net${src}`;
    }

    // Always proxy through Next.js image API
    // return `/api/files?url=${encodeURIComponent(absoluteUrl)}`;
    // return `/api/files?url=${absoluteUrl}`;
    return absoluteUrl;
}

export const srcPath = ({ src, format = "avif", loader = false }: { src: string | undefined, format?: string, loader?: boolean }) => {
    let qParams: string | undefined = src;
    // console.log("srcPath----", src)
    // debugger
    // if(!src || typeof(src) !== "string"){ return ""};
    if(src) {
        const arr: string[] = src?.split('.');
        if ((format.toLocaleLowerCase() === arr[arr?.length - 1]?.split("?")[0].toLocaleLowerCase()) && (format.toLocaleLowerCase() === "jpg" || format.toLocaleLowerCase() === "jpeg")) {
            qParams = `${qParams}${src?.includes("?") ? '&' : '?'}${'fl=progressive'}`
        } else if ((format.toLocaleLowerCase() !== arr[arr?.length - 1]?.split("?")[0].toLocaleLowerCase()) && (format.toLocaleLowerCase() === "jpg" || format.toLocaleLowerCase() === "jpeg")) {
            qParams = `${qParams}${src?.includes("?") ? '&' : '?'}${'fm=jpg&fl=progressive'}`
        } else if ((format.toLocaleLowerCase() !== arr[arr?.length - 1]?.split("?")[0].toLocaleLowerCase()) && (format.toLocaleLowerCase() !== "jpg" && format.toLocaleLowerCase() !== "jpeg")) {
            qParams = `${qParams}${src?.includes("?") ? '&' : '?'}fm=${format}`;
        }
    }
    console.log("ImageWrapper srcPath --- ", src, qParams)
    return loader ? normalizeContentfulUrl(qParams || "") : qParams;
    // const arr = src?.split('.');
    // if (["jpeg", "jpg"].includes(arr[arr?.length - 1]?.split("?")[0])) {
    //   // return `${arr.join('.')}?fm=jpg&fl=progressive`;
    //   let qParams = "";
    //   if(arr[arr?.length - 1]?.split("?")?.[1] && arr[arr?.length - 1]?.split("?")?.[1].includes("fm=avif")) {
    //     qParams = `${qParams}` 
    //     // qParams = qParams + '&fl=progressive';
    //     qParams = qParams + '';
    //   } else {
    //     // qParams = qParams + '?fm=jpg&fl=progressive';
    //     qParams = qParams + '?fm=avif';
    //   }
    //   return `${arr.join('.')}${qParams}`;
    // } else if (["png"].includes(arr[arr?.length - 1]?.split("?")[0])) {
    //   // return `${arr.join('.')}?fm=png&fl=png8`;
    //   let qParams = "";
    //   if(arr[arr?.length - 1]?.split("?")?.[1] && arr[arr?.length - 1]?.split("?")?.[1].includes("fm=avif")) {
    //     // qParams = qParams + '&fl=progressive';
    //     qParams = qParams + '';
    //   } else {
    //     // qParams = qParams + '?fm=jpg&fl=progressive';
    //     qParams = qParams + '?fm=avif';
    //   }
    //   return `${arr.join('.')}${qParams}`;
    // } else {
    //   return arr.join('.');
    // }
    // const arr = src?.split('.').slice(0, -1).join('.');

}

export const getMediaUrl = ({url, encode = true, proxy = true}: {url: string, encode?: boolean, proxy?: boolean}) => {
    // console.log("getMediaUrl ---- ", {url})
    const finalUrl = proxy ? (url ? (encode ? `/api/files?url=${encodeURIComponent(url)}` : `/api/files?url=${url}`) : "") : url || "";
    // console.log("getMediaUrl final ---- ", {finalUrl})
    return finalUrl;
}